import { Layout } from "@certn/cascadia-react";
import { CascadiaColor } from "@certn/cascadia-tokens";
import { PropsWithChildren, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { OrderStepHeader } from "./OrderStepHeader";

interface Props extends PropsWithChildren {
  disableCompletion?: boolean;
  submitting?: boolean;
  onComplete?: () => void;
  contentHeader?: ReactNode;
  rightSideBar?: ReactNode;
  hideSubmit?: boolean;
  backgroundColor?: CascadiaColor | false;
  /** Overrides the default accessible name for the layout scroll region. */
  scrollRegionAriaLabel?: string;
}

export function OrderStepLayout(props: Props) {
  const {
    disableCompletion,
    submitting,
    onComplete,
    contentHeader,
    rightSideBar,
    children,
    backgroundColor = "surface-base",
    scrollRegionAriaLabel,
  } = props;
  const { t } = useTranslation();
  const scrollableRegionLabel =
    scrollRegionAriaLabel ?? t("Order step content");

  return (
    <Layout
      layout="narrow"
      backgroundColor={backgroundColor}
      scrollableRegionLabel={scrollableRegionLabel}
      header={
        <OrderStepHeader
          onComplete={onComplete}
          isDisabled={disableCompletion}
          submitting={submitting}
        />
      }
      contentHeader={contentHeader}
      rightSideBar={rightSideBar}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {children}
      </div>
    </Layout>
  );
}
